/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToRem, pxToEm, pxToEmWithBaseline, mediaQuery, nthChildIterator} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION MODERATION SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  moderationsection: {
    '& .sectiongroupdescription': { width: '100%' },
    '& .collapsable.opened': {
      maxHeight: pxToRem(3000)
    },
    '& .tablesectionview': {
      borderCollapse: 'separate',
      borderSpacing: `0px ${pxToRem(16)}`,
      display: 'table',
      width: '100%',
      '& > .sectiongroup': {
        display: 'table-cell',
        [mediaQuery.customizeThinnest]: {
          display: 'table-row'
        }
      },
      '& .incdecfield': {
        marginTop: pxToEm(16),
        cursor: 'default !important',
        '& .field': {
          pointerEvents: 'none'
        }
      }
    },
    '& .sectiongroup': {
      '&.secondary': {
        maxWidth: '65%',
        opacity: '0',
        animationName: 'fadeInDown',
        animationDuration: '.1s',
        animationFillMode: 'forwards',
        extend: nthChildIterator(100, 0, .1),
      }
    },
    '& .group.name-controls': {
      display: 'flex',
      '& .control': {

      },
      '& .field': {
        maxWidth: pxToEmWithBaseline({ value: 513, fontSizeBaseline: 16 }),
        marginTop: pxToEmWithBaseline({ value: 12, fontSizeBaseline: 16 }),
        display: 'block',
        '& .textfield': {
          fontSize: pxToEm(14)
        }
      },
      '& .button': {
        display: 'block',
        marginTop: pxToEmWithBaseline({ value: 12, fontSizeBaseline: 14 }),
        fontSize: pxToEm(14),
        width: pxToEmWithBaseline({ value: 80, fontSizeBaseline: 14 }),
        height: pxToEmWithBaseline({ value: 48, fontSizeBaseline: 14 })
      }
    }
  }
});
